import requestCommon from "@/components/web-interface/requestCommon";
const state = {
  userDetails: null,
  feederDetails: null,
  userByIdDetails: null,
};
const actions = {
  getUserDetails(context, data) {
    let fill = "";
    if (data.filter) {
      fill = "filter=" + data.filter
    }
    return requestCommon.getInfo(
      "/users?" + fill + "&filterField=" + data.filterField + "&direction=" + data.direction + "&pageNo=" + data.pageNo + "&pageSize=" + data.pageSize + "&sortBy=" + data.sortBy,
      data,
      null,
      context,
      "getUserDetailsSuccessHandler",
      "getuserDetailsErrorHandler"
    );
  },
  onBoardNewUsers(context, payload) {
    return requestCommon.postInfo(
      "/users",
      null,
      payload,
      context,
      "OnboardNewUsersSuccessHandler",
      "OnboardNewUsersErrorHandler",
    );
  },
  updateUser(context, payload) {
    return requestCommon.patchInfo(
      "/users",
      null,
      payload,
      context,
      "updateUserSuccessHandler",
      "updateUserErrorHandler",
    );
  },
  getUserById(context, id) {
    return requestCommon.getInfo(
      "/users/" + id,
      id,
      null,
      context,
      "getUserByIdSuccessHandler",
      "getUserByIdErrorHandler"
    );
  },
  getFeederDetails(context, data) {
    return requestCommon.getInfo(
      "/users/feeders",
      null,
      null,
      context,
      "getFeederDetailsSuccessHandler",
      "getFeederDetailsErrorHandler"
    );
  },
  getFeederStatus(context, data) {
    return requestCommon.getInfo(
      "/users/status/" + data.userId,
      data,
      null,
      context,
      "getFeederStatusSuccessHandler",
      "getFeederStatusErrorHandler"
    );
  },
  getAllUsers(context, data) {
    return requestCommon.getInfo(
      "/users/details",
      null,
      null,
      context,
      "getAllUsersSuccessHandler",
      "getAllUsersErrorHandler"
    );
  }
}
const mutations = {
  getUserDetailsSuccessHandler(state, data) {
    console.log('Received data:', data);
    state.userDetails = data.server.data;
  },
  getUserDetailsErrorHandler(context, error) {
    console.log(error);
  },
  onBoardNewUsersSuccessHandler(state, data) {
    console.log('onboarding user data:', data);
  },
  onBoardNewUsersErrorHandler(context, error) {
    console.log(error);
  },
  getUserByIdSuccessHandler(state, data) {
    console.log('Received data:', data);
    state.userByIdDetails = data.server.data;
  },
  getUserByIdErrorHandler(context, error) {
    console.log(error);
  },
  updateUserSuccessHandler(state, data) {
    console.log('update user data:', data);
  },
  updateUserErrorHandler(context, error) {
    console.log(error);
  },
  getFeederDetailsSuccessHandler(state, data) {
    console.log('Received data:', data);
    state.FeederDetails = data.server.data;
  },
  getFeederDetailsErrorHandler(context, error) {
    console.log(error);
  },
  getFeederStatusSuccessHandler(state, data) {
    console.log('Received data:', data);
    state.FeederDetails = data.server.data;
  },
  getFeederStatusErrorHandler(context, error) {
    console.log(error);
  },
  getAllUsersSuccessHandler(state, data) {
    console.log('Received data:', data);
  },
  getAllUsersErrorHandler(context, error) {
    console.log(error);
  }
};
const getters = {};
export const userStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
